var jade = require("C:\\Documents and Settings\\kopperts\\My Documents\\repos\\webpack-development\\node_modules\\example-app\\node_modules\\jade-loader\\node_modules\\jade\\lib\\runtime");

module.exports = function anonymous(locals, attrs, escape, rethrow, merge) {
attrs = attrs || jade.attrs; escape = escape || jade.escape; rethrow = rethrow || jade.rethrow; merge = merge || jade.merge;
var buf = [];
var self = locals || {};
var interp;
 if(self.chunk === 0)
{
buf.push('inital bundle');
var __val__ = " "
buf.push(escape(null == __val__ ? "" : __val__));
buf.push('<span class="badge">');
var __val__ = self.chunk
buf.push(escape(null == __val__ ? "" : __val__));
buf.push('</span> (<code>web.js</code>)\n was loaded. (script-tag)');
}
 else
{
buf.push('bundle');
var __val__ = " "
buf.push(escape(null == __val__ ? "" : __val__));
buf.push('<span class="badge badge-success">');
var __val__ = self.chunk
buf.push(escape(null == __val__ ? "" : __val__));
buf.push('</span> (<code>');
var __val__ = self.chunk
buf.push(escape(null == __val__ ? "" : __val__));
buf.push('.web.js</code>)\n was loaded. (asynchron)');
}return buf.join("");
}